export default __webpack_public_path__ + "static/media/nurse.774e102a.png";